export const getIframeLink = (html: string) => {
    const regex = /https:\/\/player\.vimeo\.com\/video\/\d+/;
    const match = html.match(regex);

    if (match) {
        return match[0];
    }
    return '';
};
